export const gtagTrack = (event, type, params) => {
    if (typeof gtag !== 'undefined') {
        gtag(event, type, { ...params })
    }
}